import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Operation, OperationButtonType, TableColumn } from 'src/app/reuseableui/tablelayout/tablelayout.component';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';

@Component({
  selector: 'app-unregisteredstudents',
  templateUrl: './unregisteredstudents.component.html',
  styleUrls: ['./unregisteredstudents.component.css']
})
export class UnregisteredstudentsComponent implements OnInit {
  
  students: any;
  count: number;
  columns: TableColumn[] = [];
  filterOptions: any;
  // This list is keyed on the serialised property names. They used to carry a numeric
  // prefix ("2.Email") that encoded the column order; the order now comes from the
  // column metadata, so the plain names are what appears here and in selectBy.
  // This endpoint fills in only name and email, so the two lesson/registration columns
  // it shares with the enrolled-student list are dropped rather than shown empty.
  removeColumn = ["count", "passed", "completedLessons", "studentId", "completedLessonsString", "registeredDate"];
  selectBy = "email";
  operations: Operation[] = [];
  selectedStudents: string[];
  selectedBatchId: number;
  moduleid: any;
  schoolid: any;
  allowBatches = false;
  offset = 25;

  constructor( public modulemanager: ModulemanagementService, private schoolmanager: SchoolmanagementService,
    private toastr:ToastrService, private route: ActivatedRoute, private headerinfo: ComponentheaderService) {
  }

  async ngOnInit() {
    this.headerinfo.setHeaderDisplay(
      `List of Unregistered Student`,
      [
        {
          displaytext: 'School',
          route: `/user/schoolhome`,
        },
        {
          displaytext: 'Course',
          route: `/user/moduledetails`,
          params: { moduleID: this.moduleid },
        },
        {
          displaytext: `Unregistered Students`,
          route: `/user/unregisteredstudents`,
          params: this.route.snapshot.queryParams,
        },
      ],
      []
    );
    this.moduleid = this.route.snapshot.queryParams.moduleid; 
    this.schoolid = await this.schoolmanager.getSchoolIdFromSubdomain().toPromise();
    let schdata: any = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();
    this.allowBatches = schdata?.allowBatches;
    let op: any = [];

    if (this.allowBatches){
      let moduleBatches = await this.modulemanager.getModuleBatches(this.moduleid).toPromise();
      let childrenOperations: Operation[] = [];
      moduleBatches.forEach((m) => {
        childrenOperations.push(new Operation(`${m.name} Batch`, OperationButtonType.DropDownItem, ["fa fa-plus"], null, () => this.addStudents(), m.id ));
      });
      op.push(new Operation(`Register Students`, OperationButtonType.Dropdown, ["fa fa-plus"], childrenOperations))
    }else{
      op.push(new Operation("Register Students", OperationButtonType.Button, ["fa fa-plus"], null, () => this.addStudents()));
    }
    this.operations = op;
  }
  loadFilterData() {
    this.filterOptions = new Array();
    this.filterOptions.push(
      {
        param: 'Search',
        search: true,
        label: 'Search Name/Email',
      }
    );
  }

  private searchTermFrom(eventData): string {
    return eventData?.filters?.find(f => f["search"] == true && f["value"])?.value ?? '';
  }

  async loadTableData(eventData){
    const response: any = await this.modulemanager
      .getUnregisteredStudents(this.moduleid, eventData.page, eventData.offset, this.searchTermFrom(eventData), eventData.sortBy, eventData.sortAscending)
      .toPromise();
    this.setResult(response, eventData);
  }

  // Same shape as the activity log's setResult: rebuild the filter definitions, then hand
  // back the live array the table has been mutating, so the typed value is not discarded.
  setResult(response, eventData) {
    this.students = response?.students ?? [];
    this.columns = response?.columns ?? [];
    this.count = this.students.length > 0 ? this.students[0].count : 0;
    this.loadFilterData();
    if (eventData?.filters)
      this.filterOptions = eventData.filters;
  }

  itemSelected(data){
    this.selectedStudents = data;       
  }
  setBatchId(op : Operation) {
    if(this.allowBatches && op.Type == OperationButtonType.DropDownItem){
      this.selectedBatchId = op.Id;
    }    
  }
  private async addStudents() {    
    try{
      if(this.selectedStudents.length > 0 && this.moduleid > 0){
        let data = [];
        this.selectedStudents.forEach(async (stu) => {
          data.push({
            moduleId: this.moduleid,
            email: stu,
            schoolId: this.schoolid,
            batchId: this.selectedBatchId
          });
        })
        await this.modulemanager.enrollByAdmin(data).toPromise();
        this.students = [];
        // carry the filters through, so enrolling does not silently drop the search
        this.loadTableData({page: 1, offset: this.offset, filters: this.filterOptions})
        this.toastr.info('Registration Successful')
    }
    }   
    catch(e){
      this.toastr.error(e.message)
      console.log('error:', e);      
    }
  }
}
